import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  // Ensure fetchData is defined before accessing its properties
  const data = fetchData;
  // console.log("checking data in product", data);

  const formattedData = useMemo(() => {
    const rows = [];

    if (Array.isArray(data)) {
      data.forEach((orderItem, index) => {
        // Get Order details from the first Order_items item, if available
        const order = orderItem.Order_items?.[0]?.Order || {};
        const product = orderItem;
        const customer = order?.Customer || {};

        const row = {
          id: index,
          order_code: order?.order_code || "",
          product_id: product.product_id || "",
          product_code: product.product_code || "",
          product_name: product.product_name || "",
          category_id: product.category_id || "",
          detail: product.detail || "",
          market_status: product.market_status || "",
          blemishes: product.blemishes || "",
          size: product.size || "",
          price: product.price || "",
          sell_price: product.sell_price || "",
          total_price: product.total_price || "",
          total_amount: product.total_amount || "",
          remaining_amount: product.remaining_amount || "",
          product_type: product.product_type || "",
          created_date: product.created_date
            ? moment(product.created_date).format(
                "DD/MM/YYYY\n เวลา HH:mm:ss น."
              )
            : "",
          updated_date: product.updated_date
            ? moment(product.updated_date).format(
                "DD/MM/YYYY\n เวลา HH:mm:ss น."
              )
            : "",
          picture: product.Pictures.map((picture) => ({
            id: picture.id,
            picture: picture.pic
              .split("http")
              .filter(Boolean)
              .map((url) => `http${url.trim()}`),
          })),
          customer_id: customer?.id || "",
          customer_name: customer?.name || "",
          idcard: customer?.idcard || "",
          customer_image: customer?.image || "",
          customer_address: customer?.address || "",
          customer_phonenumber: customer?.phonenumber || "",
        };

        rows.push(row);
      });

      // console.log("Formatted Rows:", rows);
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
